/** @format — Documents API client */

import { ENDPOINTS } from "@/services/constants";
import { pythonApiClient } from "@/services/python-api/pythonApiClient";
import { unwrapDocumentsResponse } from "@/pages/documents/utils/unwrapDocumentsResponse";
import type {
  AwaitingDocumentsResponse,
  DocumentsListResponse,
  ListDocumentsParams,
  ListingsWithDocumentsResponse,
} from "@/pages/documents/types";

function buildQuery(params: ListDocumentsParams = {}) {
  const query = new URLSearchParams();
  if (params.search?.trim()) query.set("search", params.search.trim());
  if (params.sortBy) query.set("sortBy", params.sortBy);
  if (params.orderBy) query.set("orderBy", params.orderBy);
  if (params.startDate) query.set("startDate", params.startDate);
  if (params.endDate) query.set("endDate", params.endDate);
  if (params.listingId) query.set("listingId", params.listingId);
  if (typeof params.page === "number") query.set("page", String(params.page));
  if (typeof params.limit === "number") query.set("limit", String(params.limit));
  const q = query.toString();
  return q ? `?${q}` : "";
}

export async function listDocuments(params: ListDocumentsParams = {}): Promise<DocumentsListResponse> {
  const payload = await pythonApiClient.get(`${ENDPOINTS.DOCUMENTS.LIST}${buildQuery(params)}`);
  return unwrapDocumentsResponse(payload);
}

export async function listListingsWithDocuments(params: {
  search?: string;
  page?: number;
  limit?: number;
} = {}): Promise<ListingsWithDocumentsResponse> {
  const query = new URLSearchParams();
  if (params.search?.trim()) query.set("search", params.search.trim());
  if (typeof params.page === "number") query.set("page", String(params.page));
  if (typeof params.limit === "number") query.set("limit", String(params.limit));
  const q = query.toString();
  const payload = await pythonApiClient.get(`${ENDPOINTS.DOCUMENTS.LISTINGS}${q ? `?${q}` : ""}`);
  return payload as ListingsWithDocumentsResponse;
}

export async function getAwaitingDocuments(
  listingId: string,
  options: { awaitingType?: "expected" | "overdue"; search?: string } = {},
): Promise<AwaitingDocumentsResponse> {
  const query = new URLSearchParams();
  if (options.awaitingType) query.set("awaitingType", options.awaitingType);
  if (options.search?.trim()) query.set("search", options.search.trim());
  const q = query.toString();
  const payload = await pythonApiClient.get(
    `${ENDPOINTS.DOCUMENTS.AWAITING}/${listingId}/${q ? `?${q}` : ""}`,
  );
  return payload as AwaitingDocumentsResponse;
}
